// The boat's given name, falling back to the boat club name and then the
// marina name. Uses `||` (not `??`) so cleared fields persisted as empty
// strings are treated as absent and fall through to the next value.
export default function boatName(boat) {
  const { name__c, name_of_boat_club__c, marina_name__c } = boat

  return name__c || name_of_boat_club__c || marina_name__c
}
